import { alpha } from "@mui/material";
const styles = (theme) => ({
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "100%",
    left: 0,
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
  },
  boxTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    px: 2,
    py: 1,
  },
  paperHeader: {
    p: 0,
    Bottom: "1px solid",
    borderColor: "divider",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    overflow: "hidden",
    position: "relative",
  },
  accordionContainer: {
    maxHeight: 350,
    minHeight: 350,
    overflowY: "auto",
    backgroundColor: "background.paper",
  },
  accordion: {
    "&.Mui-expanded": {
      margin: 0,
    },
    "&::before": {
      display: "none",
    },
    borderBottom: "1px solid",
    borderColor: "divider",
    "&:last-of-type": {
      borderBottom: "none",
    },
  },
  accordionSummary: {
    minHeight: 40,
    "&.Mui-expanded": { minHeight: 40 },
    "& .MuiAccordionSummary-content": { margin: 0 },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: 0,
    },
    transition: "background-color 0.2s ease",
    my: -0.1,
  },
  summaryInterfaceContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "center",
  },
  summaryInterfaceStatus: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    "@keyframes pulse": {
      "0%": {
        transform: "scale(1)",
        opacity: 1,
      },
      "50%": {
        transform: "scale(1.2)",
        opacity: 0.5,
      },
      "100%": {
        transform: "scale(1)",
        opacity: 1,
      },
    },
  },
  summaryPrefixes: { display: "flex", flexDirection: "row", gap: 1 },
  summaryAnnouncedIcon: {
    color: theme.palette.cardGraphic.graphColor.orangeMedium,
  },
  summaryReceivedIcon: {
    transform: "rotate(90deg)",
    mt: 0.2,
    color: theme.palette.cardGraphic.graphColor.blueMedium,
  },
  paperAccordionDetails: {
    p: 3,
    borderRadius: 4,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
  detailsColumnContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.background.paper
        : theme.palette.white.main,

    p: 1,
    borderRadius: 3,
  },
  detailsTitleContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    mb: 0,
  },
  detailsAnnouncedIcon: {
    color: theme.palette.cardGraphic.graphColor.orangeMedium,
  },
  detailsReceivedIcon: {
    transform: "rotate(90deg)",
    mt: 0.2,
    color: theme.palette.colors.blue.medium,
  },
  detailsReceivedHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 1,
    mb: 0.5,
  },
  detailsReceivedTitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  detailsReceivedTitle: {
    fontWeight: 600,
    color:
      theme.palette.mode === "dark"
        ? theme.palette.white?.main || theme.palette.text.primary
        : theme.palette.colors?.black?.darker || theme.palette.text.primary,
  },
  detailsReceivedButton: {
    textTransform: "none",
    borderRadius: 1.5,
    fontSize: "0.72rem",
    px: 0.8,
    py: 0.1,
    borderColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
    mt: -0.345,
  },
  detailsGraphContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "184px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.background.paper
        : theme.palette.white.main,
    p: 1,
    borderRadius: 3,
  },
  detailsEvolutionIcon: {
    color: theme.palette.colors.black.medium,
  },
  detailsEvolutionTitle: {
    color:
      theme.palette.mode === "dark"
        ? theme.palette.white.main
        : theme.palette.colors.black.darker,
  },
  paperPagination: {
    p: 0,
    borderTop: "1px solid",
    borderColor: "divider",
    borderRadius: "0 0 16px 16px",
    height: 40,
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    justifyContent: "flex-end",
  },
});

export default styles;
